import React from "react";
import Navbar from "../components/Navbar";
import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";
import { FaLightbulb, FaHome, FaCouch, FaSun } from "react-icons/fa";

const HomeLightingTips = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gradient-to-br from-[#542757] to-[#9b1f6c] text-white">
      <Navbar />

      <div className="max-w-6xl mx-auto px-6 py-16 mt-10">
        <motion.h1
          className="text-4xl font-extrabold text-center text-transparent bg-clip-text bg-gradient-to-r from-pink-500 to-yellow-400 mb-10 drop-shadow-lg"
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
        >
          Home Lighting Tips
        </motion.h1>

        <motion.p
          className="text-white/80 text-lg text-center mb-12"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.2, duration: 0.6 }}
        >
          Discover how to create the perfect ambiance in every corner of your home with smart, energy-efficient lighting solutions.
        </motion.p>

        {/* Lighting Tips Sections */}
        <div className="grid md:grid-cols-2 gap-10">
          {/* Tip 1 */}
          <motion.div
            className="bg-white/10 rounded-2xl shadow-md p-6 hover:shadow-lg transition"
            whileHover={{ scale: 1.02 }}
          >
            <FaLightbulb className="text-yellow-400 text-4xl mb-4" />
            <h2 className="text-xl font-bold text-white mb-2">1. Layer Your Lighting</h2>
            <p className="text-white/80">
              Use a combination of ambient, task, and accent lighting to bring balance and flexibility to any room. Consider dimmable fixtures to adjust brightness as needed.
            </p>
          </motion.div>

          {/* Tip 2 */}
          <motion.div
            className="bg-white/10 rounded-2xl shadow-md p-6 hover:shadow-lg transition"
            whileHover={{ scale: 1.02 }}
          >
            <FaHome className="text-orange-400 text-4xl mb-4" />
            <h2 className="text-xl font-bold text-white mb-2">2. Highlight Architectural Features</h2>
            <p className="text-white/80">
              Use spotlights or wall washers to draw attention to design elements like textured walls, artwork, or statement furniture pieces.
            </p>
          </motion.div>

          {/* Tip 3 */}
          <motion.div
            className="bg-white/10 rounded-2xl shadow-md p-6 hover:shadow-lg transition"
            whileHover={{ scale: 1.02 }}
          >
            <FaCouch className="text-purple-400 text-4xl mb-4" />
            <h2 className="text-xl font-bold text-white mb-2">3. Create Cozy Corners</h2>
            <p className="text-white/80">
              Add table lamps or floor lamps near reading chairs or sofas to create inviting spaces. Warm light tones help enhance comfort and relaxation.
            </p>
          </motion.div>

          {/* Tip 4 */}
          <motion.div
            className="bg-white/10 rounded-2xl shadow-md p-6 hover:shadow-lg transition"
            whileHover={{ scale: 1.02 }}
          >
            <FaSun className="text-pink-400 text-4xl mb-4" />
            <h2 className="text-xl font-bold text-white mb-2">4. Maximize Natural Light</h2>
            <p className="text-white/80">
              Arrange mirrors or use lighter wall colors to reflect daylight deeper into your space. Combine natural and artificial lighting for an uplifting environment.
            </p>
          </motion.div>
        </div>

        {/* Call to Action */}
        <motion.div
          className="mt-16 text-center"
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.3 }}
        >
          <h3 className="text-2xl font-semibold text-white mb-3">
            Ready to Upgrade Your Home Lighting?
          </h3>
          <p className="text-white/80 mb-6">
            Explore our LED range and smart lighting solutions to bring your ideas to life.
          </p>
          {/* Filters the shop to Downlight Series (spotlights/wall washers
              mentioned above), reusing the existing filtering system */}
          <button
            type="button"
            onClick={() => navigate("/shop", { state: { category: "DOWNLIGHT SERIES" } })}
            className="inline-block bg-gradient-to-r from-pink-500 to-yellow-400 text-white font-medium px-6 py-3 rounded-full shadow-md hover:shadow-lg transition"
          >
            Browse Products
          </button>
        </motion.div>
      </div>
    </div>
  );
};

export default HomeLightingTips;
